import { Navigate } from "react-router-dom";

import { LegacyPagePaths } from "App/routes/paths";
import { lazyWithRetries } from "Utils/LazyWithRetries/LazyWithRetries";

import { taskPathResources } from "./Pages/taskPaths";
import TasksRoutingPage, { TasksRerouter, RecentTasksRerouter } from "./TasksRoutingPage";

import type { RegalRouteObject } from "App/routes/types";

const UpcomingTasksIndex = lazyWithRetries(
    "Upcoming Tasks page",
    () => import("./Pages/UpcomingTasksPage/UpcomingTasksPage")
);
const PastTasksIndex = lazyWithRetries("Past Tasks page", () => import("./Pages/PastTasksPage/PastTasksPage"));

// For legacy nav - tasks route with nested routes
export const legacyTasksRoute: RegalRouteObject = {
    path: LegacyPagePaths.tasks,
    element: <TasksRoutingPage />,
    hasNestedRoutes: true,
    children: [
        {
            index: true,
            element: <Navigate to={taskPathResources.upcoming} replace />,
        },
        {
            path: taskPathResources.upcoming,
            element: <UpcomingTasksIndex />,
        },
        {
            path: taskPathResources.past,
            element: <PastTasksIndex />,
        },
    ],
};

// For live-ops subroute (reorganized nav)
export const taskRoutes: RegalRouteObject = {
    element: <TasksRoutingPage />,
    hasNestedRoutes: true,
    children: [
        {
            index: true,
            element: <Navigate to={taskPathResources.upcoming} replace />,
        },
        {
            path: taskPathResources.upcoming,
            element: <UpcomingTasksIndex />,
        },
        {
            path: taskPathResources.past,
            element: <PastTasksIndex />,
        },
    ],
};

export const rerouteTasksRoute: RegalRouteObject = {
    path: LegacyPagePaths.tasks,
    element: <TasksRerouter />,
    children: [
        {
            path: "*",
            element: <TasksRerouter />,
        },
    ],
};

export const rerouteRecentTasksRoute: RegalRouteObject = {
    path: LegacyPagePaths.recentTasks,
    element: <RecentTasksRerouter />,
    children: [
        {
            path: "*",
            element: <RecentTasksRerouter />,
        },
    ],
};
